import qs from 'qs';
import configure, { apiUrls } from '@/constant/configure';
import api from '@/helpers/api_helper';
import delay from '@/utils/delay';

export const getShortsList = async (offset?: number, limit?: number, exceptList?: string[]) => {
    let exceptString = '';
    for (let i = 0; i < [...(exceptList || [])].length; i++) {
        if ([...(exceptList || [])].length === 0) return;
        if (!exceptList) return;
        exceptString = `${exceptString}&excludeShortsIdList=${exceptList[i]}`;
    }
    console.log('exceptString::::', exceptString);
    const queryString = `?offset=${offset || 0}&limit=${limit || 10}${exceptString}`;
    try {
        return await api.get(`/shorts${queryString}`, { baseURL: apiUrls.studio }).then((r) => r.data?.itemList || []);
    } catch (error) {
        throw error;
    }
};

export const getSourcingList = async (
    userId: string,
    query?: { offset: number; limit?: number; filterType?: string },
) => {
    const offset = query?.offset || 0;
    const limit = query?.limit || 5;
    const filterType = !!query?.filterType ? (query.filterType === 'all' ? '' : query.filterType) : '';
    const queryString = `?offset=${offset}&limit=${limit}&status=${filterType}`;
    try {
        return await api
            .get(`/seller/${userId}/sourcing-request${queryString}`, { baseURL: apiUrls.matching })
            .then((r) => {
                return {
                    list: r.data?.items || [],
                    total: r.data?.totalCount || 0,
                };
            });
    } catch (error) {
        throw error;
    }
};
interface PostPostsPropType {
    type: string;
    uploadType: 'video' | 'instagram';
    sourcingJoinId?: string;
    postUrl?: string;
    content?: string;
    videoUrl?: string;
    purchaseUrl?: string;
}
export const postPosts = async (payload: PostPostsPropType) => {
    try {
        return await api.post('/posts', { ...payload }, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};
export const patchPosts = async (postsId: string, payload: any) => {
    try {
        return await api.patch(`/posts/${postsId}`, { ...payload }, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};
// export const patchPosts = async (postsId: string, linkId: string, purchaseUrl: string) => {
//     try {
//         return await api.patch(`/posts/${postsId || ''}/purchase-link/${linkId || ''}`, {
//             purchaseUrl
//         }, { baseURL: apiUrls.studio })
//     } catch (error) { throw error }
// }
export const postPurchaseLink = async (postsId: string, purchaseUrl: string) => {
    try {
        return await api.post(
            `/posts/${postsId || ''}/purchase-link`,
            {
                purchaseUrl,
            },
            { baseURL: apiUrls.studio },
        );
    } catch (error) {
        throw error;
    }
};
export const getPosts = async (query: { offset?: number; limit?: number; name?: string }) => {
    const offset = query?.offset || 0;
    const limit = query?.limit || 15;
    const collectionName = query?.name || '';
    try {
        const queryString = `?offset=${offset || 0}&limit=${limit || 15}${!!collectionName ? `&productName=${collectionName}` : ''}`;
        return await api.get(`/posts${queryString}`, { baseURL: apiUrls.studio }).then((r) => r.data?.itemList || []);
    } catch (error) {
        throw error;
    }
};
export const getPostsByAdmin = async (query: { offset?: number; limit?: number; collectionName?: string }) => {
    const offset = query?.offset || 0;
    const limit = query?.limit || 15;
    const search = query?.collectionName || '';
    try {
        const queryString = `?offset=${offset || 0}&limit=${limit || 15}${!!search ? `&search=${search}` : ''}`;
        return await api.get(`/posts${queryString}`, { baseURL: apiUrls.studio }).then((r) => r.data || {});
    } catch (error) {
        throw error;
    }
};
export const getPost = async ({ postsId }: { postsId: string }) => {
    try {
        return await api.get(`/posts/${postsId}`, { baseURL: apiUrls.studio }).then((r) => r.data?.item || {});
    } catch (error) {
        throw error;
    }
};
export const getRelatedPosts = async (query: { offset?: number; limit?: number; name?: string }) => {
    const offset = query?.offset || 0;
    const limit = query?.limit || 15;
    const collectionName = query?.name || '';
    try {
        const queryString = `?offset=${offset || 0}&limit=${limit || 15}&collectionName=${collectionName}`;
        // return await api.get(`/posts/related-posts${queryString}`, { baseURL: apiUrls.studio }).then(r => r.data?.itemList || [])
        return [];
    } catch (error) {
        throw error;
    }
};
export const deletePost = async (postsId: string) => {
    try {
        return await api.delete(`/posts/${postsId}`, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};
export const deleteRelatedPost = async (postsId: string, linkId: string) => {
    try {
        return await api.delete(`/posts/${postsId}/auto-purchase-link/${linkId}`, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};
export const getSourcingListWithVendor = async (
    userId: string,
    query?: { offset: number; limit?: number; filterType?: string },
) => {
    const offset = query?.offset || 0;
    const limit = query?.limit || 5;
    const filterType = !!query?.filterType ? (query.filterType === 'all' ? '' : query.filterType) : '';
    const queryString = `?offset=${offset}&limit=${limit}&status=${filterType}`;
    try {
        return await api
            .get(`/seller/${userId}/vendor-sourcing-request${queryString}`, { baseURL: apiUrls.matching })
            .then((r) => {
                return {
                    list: r.data?.items || [],
                    total: r.data?.totalCount || 0,
                };
            });
    } catch (error) {
        throw error;
    }
};

interface PostShortsWatchInfoPayload {
    replyCount?: number;
    skipCount?: number;
    pauseCount?: number;
    viewTime?: number;
    videoDuration?: number;
    viewStartDate?: string;
    viewEndDate?: string;
}
export const postShortsWatchInfo = async (shortsId: string, payload: PostShortsWatchInfoPayload) => {
    try {
        return await api.post(`/shorts/${shortsId}`, { ...payload }, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};

export const postSourcingRequest = async (userId: string, payload: { shortsId: string }) => {
    try {
        return await api
            .post(`/seller/${userId}/sourcing-request`, { ...payload }, { baseURL: apiUrls.matching })
            .then((r) => r);
    } catch (error) {
        throw error;
    }
};
interface PostAbuseReportPayloadType {
    type: string;
    description: string;
    evidence: string[];
}
export const postAbuseReport = async (postsId: string, payload: PostAbuseReportPayloadType) => {
    try {
        return await api.post(`/posts/${postsId}/abuse-reports`, { ...payload }, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};

export const getSourcingSearchList = async (keyword: string, offset: number, limit: number, category: string) => {
    const queryCategory = !!category ? (category === 'all' ? '' : category) : '';
    const queryString = `?keyword=${keyword}&offset=${offset || 0}&limit=${limit || 12}&categoryId=${queryCategory}`;
    try {
        return await api
            .get(`/shorts/search${queryString}`, { baseURL: apiUrls.studio })
            .then((r) => r.data?.itemList || []);
    } catch (error) {
        throw error;
    }
};

export const postSourcingConfirm = async (userId: string, joinId: string) => {
    try {
        return await api.post(`/seller/${userId}/sourcing-join/${joinId}/confirm`, {}, { baseURL: apiUrls.matching });
    } catch (error) {
        throw error;
    }
};

export const getShortsCategoryList = async (type: string = 'main') => {
    try {
        return await api
            .get(`/shorts/category?type=${type}`, { baseURL: apiUrls.studio })
            .then((r) => r.data?.itemList || []);
    } catch (error) {
        throw error;
    }
};

export const getShortsVideoById = async (shortsId: string) => {
    try {
        return await api.get(`/shorts/${shortsId}/video`, { baseURL: apiUrls.studio }).then((r) => r.data.item || {});
    } catch (error) {
        throw error;
    }
};

export const getShortsReactionRate = async (shortsId: string) => {
    try {
        return await api
            .get(`/shorts/${shortsId}/reaction`, { baseURL: apiUrls.studio })
            .then((r) => r.data.item || {});
    } catch (error) {
        throw error;
    }
};
export const postShortsReactionRate = async (shortsId: string, type: 'LIKE' | 'DISLIKE') => {
    try {
        return await api
            .post(`/shorts/${shortsId}/reaction`, { type }, { baseURL: apiUrls.studio })
            .then((r) => r.data.item || {});
    } catch (error) {
        throw error;
    }
};
export const getShortsComments = async (postsId: string, offset?: number, limit?: number) => {
    try {
        return await api
            .get(`/posts/${postsId}/comments?offset=${offset || 0}&limit=${limit || 10}`, { baseURL: apiUrls.studio })
            .then((r) => r.data.item || {});
    } catch (error) {
        throw error;
    }
};
export const postShortsComment = async (postsId: string, payload: { content: string; commentId: string }) => {
    try {
        return await api
            .post(`/posts/${postsId}/comments`, { ...payload }, { baseURL: apiUrls.studio })
            .then((r) => r.data?.item || {});
    } catch (error) {
        throw error;
    }
};
export const deleteShortsComment = async (postsId: string, commentsId: string) => {
    try {
        return await api.delete(`/posts/${postsId}/comments/${commentsId}`, { baseURL: apiUrls.studio }).then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const reportShortsComment = async (postsId: string, commentsId: string, payload: PostAbuseReportPayloadType) => {
    try {
        return await api
            .post(`/posts/${postsId}/comments/${commentsId}/abuse-reports`, { ...payload }, { baseURL: apiUrls.studio })
            .then((r) => r);
    } catch (error) {
        throw error;
    }
};
export const getShortsRecipe = async (shortsId: string) => {
    try {
        return await api.get(`/shorts/${shortsId}/recipe`, { baseURL: apiUrls.studio }).then((r) => r.data?.item || {});
    } catch (error) {
        throw error;
    }
};
export const getQuizHistorySummary = async (start: string, end: string) => {
    try {
        return await api
            .get(`/shorts/quiz-history-statistics?startDateTime=${start}&endDateTime=${end}`, {
                baseURL: apiUrls.studio,
            })
            .then((r) => r.data?.item || {});
    } catch (error) {
        throw error;
    }
};
export const getQuizHistoryList = async (
    start: string,
    end: string,
    offset: number,
    limit: number,
    order?: 'asc' | 'desc',
) => {
    const query = `startDateTime=${start}&endDateTime=${end}&offset=${offset || 0}&limit=${limit || 15}&order=${!!order ? order : 'desc'}`;
    return await api
        .get(`/shorts/quiz-history?${query}`, { baseURL: apiUrls.studio })
        .then((r) => r.data?.itemList || []);
};
export const getWatchHistoryList = async (start: string, end: string, offset: number, limit: number) => {
    try {
        const query = `startDateTime=${start}&endDateTime=${end}&offset=${offset || 0}&limit=${limit || 15}`;
        return await api
            .get(`/shorts/history?${query}`, { baseURL: apiUrls.studio })
            .then((r) => r.data?.itemList || []);
    } catch (error) {
        throw error;
    }
};
export const getShortsStory = async (shortsId: string) => {
    try {
        return await api.get(`/shorts/${shortsId}/story`, { baseURL: apiUrls.studio }).then((r) => r.data?.item || {});
    } catch (error) {
        throw error;
    }
};
export const postQuizAnswer = async (shortsId: string, quizId: string, choiceId: string) => {
    try {
        return await api
            .post(`/shorts/${shortsId}/quiz/${quizId}/answer`, { choiceId }, { baseURL: apiUrls.studio })
            .then((r) => r.data?.item || {});
    } catch (error) {
        throw error;
    }
};

export const getJoinDataById = async (joinId: string) => {
    try {
        return await api
            .get(`/common/sourcing-join/${joinId || ''}`, { baseURL: apiUrls.matching })
            .then((r) => r.data);
    } catch (error) {
        throw error;
    }
};

export const getSourcingProductList = async (userId: string) => {
    try {
        return await api
            .get(`/posts/${userId}/product-name`, { baseURL: apiUrls.studio })
            .then((r) => r.data?.itemList || []);
    } catch (error) {
        throw error;
    }
};

export const getAuthIsMyVideoUrl = async (postsId: string) => {
    try {
        return await api.get(`/posts/${postsId}/origin`, { baseURL: apiUrls.studio }).then((r) => r.data?.url || '');
    } catch (error) {
        throw error;
    }
};

export const putAuthIsMyVideoUrl = async (postsId: string, url: string) => {
    try {
        return await api.put(`/posts/${postsId}/origin`, { url }, { baseURL: apiUrls.studio });
    } catch (error) {
        throw error;
    }
};

export const getPurchaseLinks = async (userId: string, query: { offset: number; limit: number; search?: string }) => {
    const offset = query?.offset || 0;
    const limit = query?.limit || 10;
    const value = query?.search || '';
    try {
        return await api
            .get(
                `/posts/${userId}/additional-purchase-link?offset=${offset}&limit=${limit}${!!value ? `&search=${value}` : ''}`,
                { baseURL: apiUrls.studio },
            )
            .then((r) => r.data || { itemList: [], total: 0 });
    } catch (error) {
        throw error;
    }
};

export const getIWantContent = async (sourcingRequestId: string) => {
    try {
        return await api
            .get(`/common/sourcing-request/${sourcingRequestId || ''}/items`, { baseURL: apiUrls.matching })
            .then((r) => r.data);
    } catch (error) {
        throw error;
    }
};

export const request09ByProductId = async ({
    productGroupId,
    sellerId,
}: {
    productGroupId: string;
    sellerId: string;
}) => {
    try {
        await api.post(
            `/seller/${sellerId}/sourcing-request/products`,
            { productGroupId },
            { baseURL: apiUrls.matching },
        );
    } catch (error) {
        throw error;
    }
};
